<template>
  <div :class="[`col-lg-${span}`]">
    <label>{{ label }}</label>
    <div :id="dropzoneId" class="js-dropzone dropzone-custom custom-file-boxed mb-4">
      <div class="dz-message custom-file-boxed-label">
        <h5 class="mb-2">Trascina i files qui</h5>
        <p class="mb-2">oppure</p>
        <span class="btn btn-sm btn-white">Cerca i files nel computer</span>
      </div>
    </div>

    <div class="row">
      <div v-for="(file, i) in files" :key="i" class="col-sm-6 col-lg-3 mb-4">
        <div class="report-file-preview" :class="{ deleted: file.deleted }">
          <img class="preview-content" v-if="file.mime.includes('image/')" :src="file.url" />
          <div class="preview-content" v-else>{{ file.file_name }}</div>
          <div class="delete-toggle" @click="toggleDelete(file)">
            <i v-if="file.deleted" class="tio-restore"></i>
            <i v-else class="tio-clear"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["uniqueId", "uploadRoute", "fieldKey", "mimes", "value", "label", "items", "span"],

  data() {
    return {
      files: [],
      uploadQueue: [],
      dropzone: null,
      dropzoneId: this.uniqueId
    };
  },

  mounted() {
    var CSRF_TOKEN = this.$page.props.csrf_token;
    this.dropzone = new window.Dropzone(`div#${this.dropzoneId}`, {
      url: this.uploadRoute,
      headers: { "x-csrf-token": CSRF_TOKEN },
      params: {
        mimes: this.mimes
      }
    });
    this.dropzone.on("addedfile", file => {
      this.uploadQueue.push(true);
    });
    this.dropzone.on("complete", file => {
      this.uploadQueue.pop(true);
    });
    this.dropzone.on("success", (file, response) => {
      this.dropzone.removeFile(file);
      this.files.push(response.file);
      this.$emit("update:items", this.files);
    });
  },

  watch: {
    items: {
      immediate: true,
      handler: function() {
        this.files = this.items;
      }
    },

    uploadQueue: {
      deep: true,
      handler: function() {
        this.$emit("formlock", this.uploadQueue.length > 0);
      }
    }
  },

  methods: {
    toggleDelete(file) {
      file.deleted = !file.deleted;
    }
  }
};
</script>

<style lang="scss">
.report-file-preview {
  position: relative;
  width: 100%;
  padding-top: 100%;
  border-radius: 6px;

  &.deleted {
    .preview-content {
      opacity: 0.4;
    }

    .delete-toggle {
      color: var(--dark);
    }
  }

  .preview-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .delete-toggle {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--danger);
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
  }
}

.dropzone-custom {
  .dz-preview {
    padding: 1rem;
    border: 1px solid #e7eaf3;
    margin-top: 1rem;

    &.dz-success {
      .dz-success-mark {
        path {
          fill: var(--primary);
        }
      }
    }
  }
}
</style>
